import { useEffect, useState } from "react";

interface IncludeMusicGuessOptionProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function IncludeMusicGuessOption({ checked, onChange }: IncludeMusicGuessOptionProps) {
  const [musicGuessCount, setMusicGuessCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch("/api/catalog")
      .then((r) => (r.ok ? r.json() : null))
      .then((data: { musicGuessEligible?: number } | null) => {
        if (!cancelled && data?.musicGuessEligible != null) {
          setMusicGuessCount(data.musicGuessEligible);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="space-y-1">
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span>
          Inclure les chansons MusicGuess
          {musicGuessCount != null && (
            <span className="text-violet-400/70"> ({musicGuessCount} titres)</span>
          )}
        </span>
      </label>
      <p className="text-xs text-violet-400/60 ml-6">
        Ajoute ou retire du tirage les chansons taguées « MusicGuess » dans le catalogue Hitster.
      </p>
      {checked && (
        <p className="text-sm text-red-400 ml-6 mt-2 p-3 rounded bg-red-500/10 border border-red-500/30">
          Attention, des erreurs peuvent exister dans les dates, et une certaine latence au chargement de la
          chanson est possible
        </p>
      )}
    </div>
  );
}
